import { createContext, ReactNode, useState } from 'react';
import { useAuth } from '../hooks/useAuth';
import { api } from '../server/api';

interface TransactionContextProviderProps {
  children: ReactNode;
}

interface TransactionContextProps {
  lastTransaction: any;
  statement: any;
  getStatement: (page: number) => void;
  getLastTransaction: (currency: string) => void;
  getReceipt: (transactionId: string) => void;
}

export const transactionContext = createContext({} as TransactionContextProps);

export function TransactionContextProvider(
  props: TransactionContextProviderProps
) {
  const { player } = useAuth();
  const [lastTransaction, setLastTransaction] = useState();
  const [statement, setStatement] = useState();

  async function getStatement(page: number) {
    try {
      const response = await api.get(
        `/statement/${player?.id}?currentPage=${page}`
      );

      if (!response.data.body.error) {
        setStatement(response.data.body.statementTransactions);
      }
    } catch (error) {
      console.log('getStatement error: ', error);
    }
  }

  async function getLastTransaction(currency: string) {
    try {
      const response = await api.get(
        `/transactions/find/${player?.id}/last?currency=${currency}`
      );
      if (response.data.body) {
        setLastTransaction(response.data.body);
      }
    } catch (error) {
      console.log('getLastTransaction error: ', error);
    }
  }

  async function getReceipt(transactionId: string) {
    try {
      const response = await api.get(`/receipt/${transactionId}`);

      if (response.data.body) {
        setLastTransaction(response.data.body);
      }
    } catch (error) {
      console.log('getReceipt error: ', error);
    }
  }

  return (
    <transactionContext.Provider
      value={{
        lastTransaction,
        statement,
        getStatement,
        getLastTransaction,
        getReceipt,
      }}
    >
      {props.children}
    </transactionContext.Provider>
  );
}
